<div class="text-gray-400 font-italic pt-2 md:pt-0">
  {{ 'LINKED_PLAYERS_PLAYER_PROFILE_MSG' | translate }}
</div>

<p-divider/>

<div>
  <app-loading [active]="isLoading"/>
  <app-message [active]="!!errorMsg" [message]="errorMsg"/>

  @if (mandantList?.length > 0) {
    <div>
      {{ 'PLEASE_SELECT_YOUR_ASSOCIATION' | translate }}
    </div>
    <div class="pt-2">
      <p-select id="client" appendTo="body"
                [options]="mandantList"
                [(ngModel)]="selectedMandant"
                [filter]="true" [showClear]="true"
                [filterBy]="'name,nameShort,mandantKey'"
                [placeholder]="'PLEASE_SELECT' | translate"
                [virtualScroll]="true"
                [virtualScrollItemSize]="34"
                optionLabel="name"
                class="grid-comp-full-width">
        <ng-template let-option pTemplate="item">
          <div class="flex">
            <div class="flex-1">
              {{option.name}}
              @if (option.nameShort) {
                ({{option.nameShort}})
              }
            </div>
            <div class="text-gray-500 pl-2">{{option.mandantKey}}</div>
          </div>
        </ng-template>
      </p-select>
    </div>

    <div class="pt-3">
      @if (selectedMandant) {
        @if (!noMembershipNumber) {
          <div>
            {{ 'PLEASE_ENTER_YOUR_MEMBERSHIP_NUMBER' | translate }}
          </div>
        }
        <div class="flex flex-column md:flex-row gap-2 align-items-center pt-2">
          @if (!noMembershipNumber) {
            <div class="flex-1 w-full">
              <input pInputText [(ngModel)]="membershipNumber" type="text" class="p-inputtext w-full" [maxlength]="50"
                     [disabled]="noMembershipNumber" (keydown.enter)="onOkClicked()">
            </div>
          }
          <!--<app-switch [(value)]="noMembershipNumber" label="ASSOCIATION_HAS_NO_MEMBERSHIP_NUMBER"/>-->
        </div>
        @if (noMembershipNumber) {
          <div class="pt-3">
            {{ 'PLEASE_ENTER_YOUR_NAME' | translate }}
          </div>
          <div class="formgrid grid pt-2">
            <div class="field col-6 md:col-3">
              <label class="text-gray-400">
                {{'PERSON_FIRSTNAME' | translate}}
              </label><br>
              <input type="text" pInputText class="p-inputtext grid-comp-full-width" [disabled]="true"
                     [(ngModel)]="firstname" [maxlength]="100">
            </div>
            <div class="field col-6 md:col-3">
              <label class="text-gray-400">
                {{'PERSON_LASTNAME' | translate}}
              </label><br>
              <input type="text" pInputText class="p-inputtext grid-comp-full-width" [disabled]="true"
                     [(ngModel)]="lastname" [maxlength]="100">
            </div>
          </div>
        }
      }
    </div>
  }
</div>

<div class="flex justify-content-end pt-3">
  <app-dialog-button [loading]="isSaving"
                     labelOkButton="LINK_PLAYER"
                     [okButtonDisabled]="!((!noMembershipNumber && membershipNumber) || (noMembershipNumber && firstname && lastname))"
                     (onOkClicked)="onOkClicked()"
                     (onCancelClicked)="onCancelClicked()"/>
</div>
